<script setup lang="ts">
import type { CustomerActiveSubscription } from '@entities/customer'

import { AppText } from '@shared/ui/typography'

import CustomerSubscriptionCard from './CustomerSubscriptionCard.vue'

defineOptions({
  name: 'CustomerPurchaseInfo',
})

defineProps<{
  subscriptions: CustomerActiveSubscription[]
  canManage: boolean
}>()
</script>

<template>
  <div
    v-if="subscriptions.length"
    class="customer-info-group"
  >
    <AppText name="body1-medium">
      Purchase
    </AppText>
    <div class="customer-purchase">
      <CustomerSubscriptionCard
        v-for="subscription in subscriptions"
        :key="subscription.id"
        :subscription="subscription"
        :can-manage="canManage"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./CustomerInfoGroup.scss" />
